import React from 'react';

import Typography from '../Typography';
import { IndividualStepStyled, ProgressStepWrapperStyled } from './style';

type StepType = {
  label: string;
  stepNumber: number;
};

type Props = {
  completedStep?: number;
  inProgressStep?: number;
  steps: StepType[];
};

const ProgressStep = ({
  completedStep = 1,
  steps,
  inProgressStep = 1,
}: Props) => {
  return (
    <ProgressStepWrapperStyled>
      {steps.map((step, idx) => (
        <IndividualStepStyled
          key={`${step.stepNumber}-${idx}`}
          $stepType={
            step.stepNumber <= completedStep
              ? 'completed'
              : step.stepNumber === inProgressStep
                ? 'in-progress'
                : 'pending'
          }
        >
          <Typography variant="caption" ellipsis className="step-label">
            {step.label}
          </Typography>
        </IndividualStepStyled>
      ))}
    </ProgressStepWrapperStyled>
  );
};

export default ProgressStep;
